import React, { Component } from 'react';
import { Box } from '@material-ui/core';
import './fonts.css'

export default class AppContainer extends Component{
    constructor(props){
      super(props)
    }
    
    componentDidMount(){
      let fontStylesArr = window.ThemeFonts.map((f) => {
        return f.cssImport
      })
      let css = fontStylesArr.join('\n'),
      style = document.getElementById('emaze-fonts');
      style.type = 'text/css';
      if (style.styleSheet){
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }
  
    render(){
      return(
        <Box>
          {this.props.children}
        </Box>
      )
    }
}